module.exports = __webpack_public_path__ + "img/album18_59.5efc33fb.jpg";